<template>
  <v-dialog :modelValue="dialog" @click:outside="$emit('close')" @keydown.esc="$emit('close')" max-width="1200px">
    <v-card>
      <!-- El v-form es para que tome el estilo de titulo de los modales (_general.scss) -->
      <v-form @submit.prevent>
        <v-card-title>
          <span class="headline">Historial de la política</span>
        </v-card-title>

        <v-card-text>
          <div class="px-2 py-1 mb-3 bg-subtitle-section">
            <p class="text-subtitle-1 mb-0"><b>Regla</b></p>
          </div>
          <v-row v-if="rule" class="mb-2">
            <v-col cols="12" md="6">
              <span class="text-caption text-medium-emphasis d-block">Producto</span>
              {{ rule.product ? rule.product.name : "-" }}
              <span class="text-caption text-grey-600 d-block">SKU: {{ rule.product ? rule.product.sku : "-" }}</span>
            </v-col>
            <v-col cols="12" md="3">
              <span class="text-caption text-medium-emphasis d-block">Almacén</span>
              {{ rule.almacen ? rule.almacen.name : "-" }}
            </v-col>
            <v-col cols="12" md="3">
              <span class="text-caption text-medium-emphasis d-block">Mín / Máx actual</span>
              <b>{{ valor(rule.stock_min) }} / {{ valor(rule.stock_max) }}</b>
            </v-col>
          </v-row>

          <div class="px-2 py-1 mb-3 bg-subtitle-section">
            <p class="text-subtitle-1 mb-0"><b>Cambios</b></p>
          </div>

          <p v-if="!loading && list.length == 0" class="text-body-2 text-medium-emphasis text-center my-4">La política todavía no registró cambios para esta regla.</p>

          <v-data-table
            v-else
            :headers="headers"
            :items="list"
            :loading="loading"
            loading-text="Cargando..."
            density="compact"
            :items-per-page="10"
            items-per-page-text="Filas por página"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td style="white-space: nowrap">{{ formatFecha(item.fecha) }}</td>
                <td class="text-center" style="white-space: nowrap">
                  <template v-if="item.stock_min_antes != null || item.stock_max_antes != null">
                    <span class="text-medium-emphasis">{{ valor(item.stock_min_antes) }} / {{ valor(item.stock_max_antes) }}</span>
                    <v-icon size="x-small" class="mx-1">mdi-arrow-right</v-icon>
                  </template>
                  <b>{{ valor(item.stock_min_despues) }} / {{ valor(item.stock_max_despues) }}</b>
                </td>
                <td>
                  <span v-if="item.ubicaciones_agregadas" class="d-block">
                    <span v-for="(code, i) in codigos(item.ubicaciones_agregadas)" :key="code" class="text-no-wrap">{{ i == 0 ? "+ " : "" }}{{ code }}{{ i < codigos(item.ubicaciones_agregadas).length - 1 ? ", " : "" }}</span>
                  </span>
                  <span v-if="item.ubicaciones_quitadas" class="d-block text-medium-emphasis">
                    <span v-for="(code, i) in codigos(item.ubicaciones_quitadas)" :key="code" class="text-no-wrap">{{ i == 0 ? "− " : "" }}{{ code }}{{ i < codigos(item.ubicaciones_quitadas).length - 1 ? ", " : "" }}</span>
                  </span>
                  <span v-if="!item.ubicaciones_agregadas && !item.ubicaciones_quitadas">-</span>
                </td>
                <td class="text-center text-medium-emphasis">{{ formatDecimal(item.demanda_diaria) }}</td>
                <td class="text-body-2 py-2">{{ item.mensaje || "-" }}</td>
              </tr>
            </template>
          </v-data-table>
          <p class="text-caption text-medium-emphasis mb-0" v-if="total > list.length">Mostrando los últimos {{ list.length }} de {{ total }} cambios.</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { reposicionRuleService } from "@/libs/ws/reposicionRuleService";

export default {
  props: {
    dialog: Boolean,
    rule: Object,
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      headers: [
        { title: "Fecha", key: "fecha", sortable: false, align: "start" },
        { title: "Mín / Máx", key: "stock", sortable: false, align: "center" },
        { title: "Ubicaciones", key: "ubicaciones", sortable: false, align: "start" },
        { title: "Demanda diaria", key: "demanda_diaria", sortable: false, align: "center" },
        { title: "Mensaje", key: "mensaje", sortable: false, align: "start" },
      ],
    };
  },
  watch: {
    dialog() {
      if (this.dialog && this.rule != null) this.loadLog();
    },
  },
  methods: {
    loadLog() {
      this.loading = true;
      this.list = [];
      this.total = 0;
      reposicionRuleService
        .politicas_log({ rule_id: this.rule.id, limit: 200 })
        .then((response) => {
          if (response.status) {
            this.list = response.result.list;
            this.total = response.result.total;
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((e) => {
          console.log("politicas_log error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //El log guarda las ubicaciones como texto "A, B"
    codigos(texto) {
      return String(texto)
        .split(",")
        .map((c) => c.trim())
        .filter((c) => c != "");
    },
    formatFecha(fecha) {
      //Doctrine serializa el datetime como objeto {date, timezone_type, timezone}
      if (fecha == null) return "-";
      const str = typeof fecha === "object" && fecha.date ? fecha.date : String(fecha);
      return str.substring(0, 19);
    },
    valor(value) {
      return value === null || value === undefined ? "-" : value;
    },
    formatDecimal(value) {
      if (value === null || value === undefined || value === "") return "-";
      return parseFloat(value).toFixed(2);
    },
  },
};
</script>
